import type { IInvestigationReport } from '@apis/investigationReports';
import { RecentCardShell } from '../RecentReports/RecentCardShell';
import styles from '../RecentReports/RecentCardShell.module.css';

interface IContractorAnalysisRecentCardProps {
  submission: IInvestigationReport;
  siteId: string;
}

/**
 * Recent-rail rendering for a contractor-analysis submission. Reads the
 * variant `professionLabel` off the record (the registry guarantees this
 * card only receives `contractorAnalysis` submissions).
 *
 * No date in the meta row: a contractor analysis is keyed on the profession
 * and spans all time, so the record stores no `investigatedTimestamp`. This
 * card used to render one anyway — first a `Date.now()` fabricated at submit
 * time, then the archive date via the read-side fallback — both of which
 * showed the moment the report was *created* in the slot reserved for the day
 * it was *about*. `RecentCardShell` already shows the creation time, honestly
 * labelled, in its top-right slot.
 */
export function ContractorAnalysisRecentCard({ submission, siteId }: IContractorAnalysisRecentCardProps) {
  const label = submission.professionLabel ?? submission.professionId ?? '';
  return (
    <RecentCardShell
      reportType="contractorAnalysis"
      reportId={submission.reportId}
      siteId={siteId}
      createdAtIso={submission.dateGeneratedIso}
      title={submission.title}
    >
      {label && <span className={styles.subtitle}>{label}</span>}
    </RecentCardShell>
  );
}
